export default __webpack_public_path__ + "static/media/todoweb.c3e1e872.png";